import './App.scss';
import { observer } from "mobx-react-lite";
import { store } from './stores/Store';
import Loader from './components/Loader';
import { FullScreenModal } from './components/FullScreenModal';
import BottomSummary from './components/BottomSummary';
import Controls from './components/Controls';

import Modals from './modals/Modals.jsx';
import AppTopBar from './components/AppTopBar.jsx';
import Render from './components/Render.jsx';
import MattressBanner from './components/MattressBanner.jsx';

import LogoLoader from './components/LogoLoader.jsx';
import { _t } from './utils/Lang';





const App = observer(() => {


    // useEffect(() => {
    //     store.loadConfiguration();
    // }, [])

    return (
        <div className="App">
            <FullScreenModal
                className="AppModal"
                isOpen={store.isOpen}
                onClose={e => {
                    store.hideModal();
                }}
            >

                <LogoLoader
                    zIndex={100}
                    className='Loader__showbox--big'
                    text={_t('loading')}
                    visible={store.pendingRequest} />
                <div className="grid">

                    <div className="grid-top">
                        <AppTopBar />
                    </div>

                    <div className="grid-render sticky-content--mobile">

                        <Render />
                    </div>
                    <div className="grid-controls">
                        {
                            store.pendingRequest ? <Loader visible /> : <Controls />
                        }

                    </div>

                    <div className="grid-summary">
                        <BottomSummary />

                    </div>
                </div>


                <Modals />

                <MattressBanner />

            </FullScreenModal>
        </div>)

})
App.displayName = 'App'


export default App;
